import { ChevronLeft, ChevronRight } from "lucide-react";

import { useT } from "@/lib/i18n";

import { Button } from "./button";

export function Pagination({
  page,
  count,
  pageSize,
  onPage,
}: {
  page: number;
  count: number;
  pageSize: number;
  onPage: (p: number) => void;
}) {
  const { t } = useT();
  const pages = Math.max(1, Math.ceil(count / pageSize));
  if (count <= pageSize) return null;
  return (
    <nav aria-label="pagination" className="mt-4 flex items-center justify-between gap-3 text-sm">
      <span className="text-muted-foreground">{t("common.total", { n: count })}</span>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          aria-label={t("common.prev")}
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
        >
          <ChevronLeft className="size-5" />
        </Button>
        <span>
          {page} / {pages}
        </span>
        <Button
          variant="outline"
          size="icon"
          aria-label={t("common.next")}
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
        >
          <ChevronRight className="size-5" />
        </Button>
      </div>
    </nav>
  );
}
